export function accordion() {
    const configureAccordion = function (el) {
        const triggers = el.querySelectorAll('.accordion-trigger');
        triggers.forEach(trigger => trigger.addEventListener('click', e => {
            var current = e.target.classList.contains('active');
            document.querySelectorAll('.accordion-trigger.active').forEach(t => t.classList.remove('active'));
            if (!current)
                e.target.classList.add('active');
        }));
    };

    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach(accordion => configureAccordion(accordion));

}
